import Positonai from "../../images/componentassets/min/Positonai-cut-min.jpg";
import PosiVault from "../../images/componentassets/min/PosiVault-cut-min.jpg";
import spacelabImg from "../../images/componentassets/min/SpaceLab-cut-min.jpg";
import portfolio_v2Img from "../../images/componentassets/min/portfolio_v2-min.jpg";
import firefliesImg from "../../images/componentassets/min/Fireflies-min.jpg";
import empoweredImg from "../../images/componentassets/min/EmpoweredU-min.jpg";
import sunriseImg from "../../images/componentassets/min/Sunrise-min.jpg";
import websiteImg from "../../images/componentassets/min/MyWebsite-min.jpg";
import mydeskImg from "../../images/componentassets/min/my-desk-min.jpg";
import webstyleImg from "../../images/componentassets/min/webstyle-min.jpg";
import exoplanetariumImg from "../../images/componentassets/min/Exoplanetarium-min.jpg";

export const featuredList = [
  /*{
    name: "Commission on Teacher Credentialing Public Website",
    imgUrl: Positonai,
    imgAlt: "A website landing page",
    description:
      "Worked as a member of the Web Services Team to migrate the CTC's public website to a new CMS and perform a hollistic system upgrade.",
    tools: "HTML · CSS · Sitefinity · CA Web · SharePoint",
    projectLink: "https://positon.ai/",
  },*/
  {
    name: "Positon.ai",
    imgUrl: Positonai,
    imgAlt: "A website landing page",
    description:
      "The Positon website where you can explore solutions, use cases, company news and history.",
    tools: "React.js · Node.js · TypeScript · Tailwind",
    projectLink: "https://positon.ai/",
  },
  {
    name: "PosiVault",
    imgUrl: PosiVault,
    imgAlt: "A website landing page",
    description: "An AI-powered SaaS application for programmatic M&A.",
    tools: "Next.js · GraphQL · Prisma (ORM) · Nexus",
    projectLink: "https://positon.ai/#solutions",
  },
  {
    name: "Exoplanetarium 3D",
    imgUrl: exoplanetariumImg,
    imgAlt: "Large text that says Exoplanetarium over a starry background",
    description:
      "An educational and interactive 3D web app that renders " +
      "NASA/Caltech data from the K2 and Keplar " +
      "missions on over 9,000 Exoplanets.",
    tools: "React.js · Three.js · WebGL",
    projectLink: "http://spacelab.space/projects",
    githubLink: "https://github.com/spacelabdev/Exoplanetarium-3D",
  },
  {
    name: "SpaceLab.space",
    imgUrl: spacelabImg,
    imgAlt: "Large text that says SpaceLab over a starry background",
    description:
      "The SpaceLab website where you can learn about the organization, " +
      "explore NASA and CalTech data, and make donations.",
    tools: "React.js · Node.js · Bootstrap",
    projectLink: "http://spacelab.space/",
    githubLink: "https://github.com/spacelabdev/spacelab-react",
  },
];

export const projectList = [
  {
    name: "Portfolio V2",
    imgUrl: portfolio_v2Img,
    imgAlt: "Large white text that says Laura Hiller over dark background",
    description:
      "The second iteration of my portfolio website." +
      " Designed to be more accessible, more responsive, and more efficient.",
    tools: "React.js · Three.js · Sass",
    projectLink: "#hero",
    githubLink: "https://github.com/lauraehiller/Portfolio_v2",
  },
  {
    name: "My Desk",
    imgUrl: mydeskImg,
    imgAlt: "A dark room with a desk and bookshelf",
    description:
      "A 3D model of my desk that I designed to practice " +
      "modeling in Blender and to familiarize myself with React-three/fiber.",
    tools: "React-three/fiber · Blender",
    projectLink: "https://lauraehiller.github.io/my-desk/",
    githubLink: "https://github.com/lauraehiller/my-desk",
  },
  {
    name: "Webstyle",
    imgUrl: webstyleImg,
    imgAlt: "A white web page with black text",
    description:
      "A fun website for trying out different color and font " +
      "combinations.  Designed as practice with JavaScript.",
    tools: "HTML · CSS · Vanilla JavaScript",
    projectLink: "https://lauraehiller.github.io/WebStyleProject/",
    githubLink: "https://github.com/lauraehiller/WebStyleProject",
  },
  {
    name: "3D World: Fireflies",
    imgUrl: firefliesImg,
    imgAlt: "A wood cabin in a swamp at night",
    description:
      "A beautiful 3D world I designed for Computer Graphics. " +
      "Fun Fact: There are about 12,000 fireflies in this world.",
    tools: "Three.js · WebGL · Blender · HTML · CSS",
    projectLink: "https://lauraehiller.github.io/3D-fireflies/",
    githubLink: "https://github.com/lauraehiller/3D-fireflies/",
  },
  {
    name: "3D World: Sunrise",
    imgUrl: sunriseImg,
    imgAlt: "A sunrise over a distant city",
    description:
      "A project for Computer Graphics in which " +
      "I wrote custom shaders to create the lighting effects and to " +
      "interpolate the sky color (creating the sunrise/sunset aesthetic).",
    tools: "WebGL · HTML · CSS · JavaScript.",
    projectLink: "https://lauraehiller.github.io/3D-sunrise/",
    githubLink: "https://github.com/lauraehiller/3D-sunrise/",
  },
  {
    name: "Portfolio V1",
    imgUrl: websiteImg,
    imgAlt: "Large text that says Laura Hiller",
    description: "The very first version of my portfolio website.",
    tools: "Bootstrap · HTML · CSS · Javascript",
    projectLink: "https://lauraehiller.github.io/Portfolio_v1/",
    githubLink: "https://github.com/lauraehiller/Portfolio_v1",
  },
  {
    name: "EmpoweredU",
    imgUrl: empoweredImg,
    imgAlt: "A person sitting with a laptop and cup of coffee",
    description:
      "A user friendly and responsive website made for a client.  Designed to be accessible to non tech-savvy contributors.",
    tools: "WordPress · HTML",
    projectLink: "", // Website: https://myempoweredu.com/ was taken down
    githubLink: "",
  },
];
